import { ObjectHelpers } from "../../helpers/object-helpers";
import { ChartType } from "../enum/chart-type.enum";

export class ChartTypeOptionModel {
    public text = '';
    public symbol = '';
    public type = ChartType.Candlestick;

    constructor(data: any) {
        this.cast(data);
    }

    private cast(data: any) {
        ObjectHelpers.setProperties(data, this, true);
    }
}
